export const EV_PATHS = {
  TRANSFER: "/smart-charging/ev/transfer/",
  COMPATIBILITY: "/smart-charging/ev/compatibility",
  TERMS: "/smart-charging/ev/terms",
  ADD_ON: "/smart-charging/ev/add-on",
  EV_SUCCESS: "/smart-charging/ev/add-on/connecting-success",
  EV_FAILED: "/smart-charging/ev/add-on/connecting-error",
};

export const EV_ROUTES = [
  EV_PATHS.TRANSFER,
  EV_PATHS.COMPATIBILITY,
  EV_PATHS.TERMS,
  EV_PATHS.ADD_ON,
  EV_PATHS.EV_SUCCESS,
  EV_PATHS.EV_FAILED,
];
